import { useShell } from '../shell/use-shell.js';

// ---------------------------------------------------------------------------
// usePlaytestsRealtime.
//
// Thin wrapper exposing the shell-owned realtime counter for playtests.
// Pages refetch their own local list in a useEffect that depends on
// `playtestsVersion`; ShellProvider owns the actual supabase channel so we
// stay under the "one supabase channel name per app" rule.
//
// `bumpPlaytestsVersion` is exposed for callers that mutate via RPC and
// want to force a refetch without waiting on the realtime echo (notably
// DELETE, which Postgres Realtime drops when a row filter is set because
// the post-image needed to evaluate the filter does not exist - same
// gotcha that bit the feedback_forms surface).
// ---------------------------------------------------------------------------

export function usePlaytestsRealtime(): {
  playtestsVersion: number;
  bumpPlaytestsVersion: () => void;
} {
  const { playtestsVersion, bumpPlaytestsVersion } = useShell();
  return { playtestsVersion, bumpPlaytestsVersion };
}
